import React from "react";
import { TableCell, Tooltip, useMediaQuery } from "@mui/material";

const EllipsisCell = ({ value, maxWidth, align = "left", children, sx = {}, sticky }) => {
    const isSmall = useMediaQuery("(max-width:600px)");
    const rawContent = children ?? value;

    const content =
        rawContent === null || rawContent === undefined || rawContent === ""
            ? "-"
            : rawContent;

    const isStickyRight = sticky === "right";

    return (
        <TableCell
            align={align}
            sx={{
                
                ...(isStickyRight && {
                    position: "sticky",
                    right: 0,
                    zIndex: 5,
                    backgroundColor: "white", 
                    
                    boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.12)",
                    width: maxWidth ?? 180,
                    minWidth: maxWidth ?? 180,
                    maxWidth: maxWidth ?? 180,
                }),

                ...(!isStickyRight && {
                    width: maxWidth ?? "auto",
                    minWidth: maxWidth ?? "auto",
                    maxWidth: isSmall ? "100%" : (maxWidth ?? "200px"),
                }),

                whiteSpace: isSmall ? "normal" : "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                wordBreak: "break-word",
                ...sx,
            }}
        >
            {typeof content === "string" && content.length > 0 ? (
                <Tooltip title={content} disableInteractive enterDelay={400}>
                    <span>{content}</span>
                </Tooltip>
            ) : (
                content
            )}
        </TableCell>
    );
};

export default EllipsisCell;
